import * as React from "react";

const File: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="31"
            viewBox="0 0 24 31"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <path d="M21.6737993,5.74217381 L16.7577725,0.826147017 C16.2304301,0.298804524 15.5155766,0 14.7714263,0 L2.81249329,0 C1.25976262,0.0058364729 0,1.26559909 0,2.81832977 L0,27.1932717 C0,28.7460023 1.25976262,30.0057649 2.81249329,30.0057649 L19.6874531,30.0057649 C21.2401837,30.0057649 22.4999464,28.7460023 22.4999464,27.1932717 L22.4999464,7.73435656 C22.4999464,6.99020626 22.2011418,6.2695163 21.6737993,5.74217381 Z M20.3495494,7.07220299 C20.4726303,7.1952839 20.554627,7.34176793 20.595654,7.50581859 L14.9999642,7.50581859 L14.9999642,1.91012881 C15.1640149,1.95115578 15.3104989,2.0331525 15.4335798,2.15623342 L20.3495494,7.07220299 Z M19.6874531,28.1307694 L2.81249329,28.1307694 C2.29688097,28.1307694 1.87499553,27.708884 1.87499553,27.1932717 L1.87499553,2.81832977 C1.87499553,2.30271744 2.29688097,1.880832 2.81249329,1.880832 L13.1249687,1.880832 L13.1249687,7.97456747 C13.1249687,8.75385105 13.7519318,9.38081412 14.5312154,9.38081412 L20.6249508,9.38081412 L20.6249508,27.1932717 C20.6249508,27.708884 20.2030654,28.1307694 19.6874531,28.1307694 Z"></path>
        </svg>
    );
};

export default React.memo(File);
